import { Module } from "vuex";
import { RootState } from "../types";
import { CropsState } from "./types";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export const crops: Module<CropsState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
